import {ButtonLink} from '@/components/ui/button-link/ButtonLink'
import {CheckDone01Icon} from '@/components/ui/icon/Icon'
import {Text} from '@/components/ui/text/Text'
import {Tooltip} from '@/components/ui/tooltip/Tooltip'
import {useGetProject} from '@/features/projects/queries/useGetProject'
import {StyledRenewedTooltipContent} from '@/features/projects/components/renewed-tooltip/style'
import {useTranslation} from '@/translations/i18n'
import dayjs from 'dayjs'
import {projectRefTypeMapToLabel} from '../../utils'
import {ProjectRefType} from '../../types'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'

export const RenewalTooltip = ({projectId, projectRefType}: {projectId: string; projectRefType: ProjectRefType}) => {
    const {t} = useTranslation()
    const {
        data: renewedProject,
        isLoading,
        isError
    } = useGetProject({
        urlParams: {
            projectId: projectId
        },
        params: {
            responseType: 'small'
        }
    })

    const renderContent = () => {
        return (
            <StyledRenewedTooltipContent align="center" gap={1} paletteKey="neutral">
                <CheckDone01Icon size={16} />
                <Text palette="neutral" shade="500" size="textSm" weight="400" style={{textDecoration: 'underline'}}>
                    {t(projectRefTypeMapToLabel[projectRefType])}
                </Text>
            </StyledRenewedTooltipContent>
        )
    }

    if (!renewedProject || isLoading || isError) return renderContent()

    return (
        <Tooltip
            content={
                <Flexbox align="start" direction="column">
                    <Text palette="neutral" shade="600" size="textXs" weight="400">
                        {t('projects:previous_project')}
                    </Text>
                    <ButtonLink
                        to={`/projects/${renewedProject.id}`}
                        variant="tertiary"
                        size="sm"
                        shape="text"
                        style={{whiteSpace: 'nowrap'}}
                        target="_blank"
                    >
                        {t('projects:code_date', {
                            code: renewedProject.code,
                            date: dayjs(renewedProject.startDate).format('DD/MM/YYYY')
                        })}
                    </ButtonLink>
                </Flexbox>
            }
            variant="light"
            contentProps={{side: 'top'}}
        >
            <div style={{cursor: 'pointer'}}>{renderContent()}</div>
        </Tooltip>
    )
}
